exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divDisplay{overflow:scroll;height:400px;background-color:hsla(0,0%,83%,.5);color:#000}textarea{-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;white-space:nowrap}.marginResearch{margin-right:10px}#marginBtnReset{margin-right:15px}#divResearch{padding-right:15px;padding-left:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-86020340","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Parameter.vue
// module id = 684
// module chunks = 0